import $ from 'jquery'

export default () => {
    $('form.needs-validation').on('submit', function (e) {
        let form = $(e.target)

        if (form.get(0).checkValidity() === false) {
            e.preventDefault()
            e.stopPropagation()
        }

        form.addClass('was-validated')
    })
}

export function validateSelectize ($form) {
    let valid = true

    $form.find('.selectize-validate[data-required="true"]')
        .each((index, element) => {
            let selectize = element.selectize

            if (selectize.getValue() === '') {
                selectize.$wrapper.addClass('invalid')
                selectize.$control.addClass('invalid')
                valid = false
            }

            selectize.off('change')
            selectize.on('change', function (value) {
                // console.log(selectize);
                if (value !== '') {
                    selectize.$wrapper.removeClass('invalid')
                }
            })
        })

    return valid
}
